export const NFZ_REGIONAL_BRANCH_LIST = '/api/NfzRegionalBranch/List';
export const PATIENT_INSURANCE_DECLARATION =
    '/api/PatientInsurance/Declaration';
